import React, { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getAllBlogs } from '../config/url';
import formatDate from '../utils/formatDate';
import { Link } from 'react-router-dom';

const HealthWellness = () => {
  const [render, setRender] = useState(null);
  const [currentBlogs, setCurrentBlogs] = useState(null);
  const [blogs, setBlogs] = useState([]); // List of blogs
  const [search, setSearch] = useState(''); // Search input value
  const [filter, setFilter] = useState(''); // Filter value
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [blogsPerPage] = useState(10); // Number of blogs per page

  // Dummy user data (replace with actual user data)
  const data = useFetchData(getAllBlogs, config);

  // Pagination
  useEffect(() => {
    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    setCurrentBlogs(blogs.slice(indexOfFirstBlog, indexOfLastBlog));
  }, [render]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // Filter and search
  useEffect(() => {
    if (data) {
      let filteredBlogs = data;
      if (filter === 'Sort by Type') {
        filteredBlogs = data.sort((a, b) =>
          a.categories[0] > b.categories[0] ? 1 : -1
        );
      }

      if (search) {
        filteredBlogs = filteredBlogs.filter((blog) =>
          Object.values(blog)
            .join(' ')
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }
      setBlogs(filteredBlogs);
      setRender(Math.floor(Math.random() * 10));
    }
  }, [search, filter, data]);
  const navigate = useNavigate();
  return (
    <>
      <div className='container my-4'>
        <div className='d-flex justify-content-between align-items-center my-4'>
          <div>
            <Link to='/content/createblog'>
              <Button variant='primary'>Add Blog</Button>
            </Link>
          </div>
          <div className='d-flex'>
            <div className='me-2'>
              <input
                type='text'
                className='form-control rounded'
                placeholder='Search by Title'
                style={{ maxWidth: '300px' }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <select
                className='form-select'
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value=''>Select Filter</option>
                <option value='Sort by Type'>Sort by Type</option>
              </select>
            </div>
          </div>
        </div>
        <Table
          responsive='xl'
          className='table bg-white rounded table-hover mb-4'
          style={{ borderCollapse: 'separate', borderSpacing: '0 1rem' }}
        >
          <thead className='bg-light'>
            <tr>
              <th>Title</th>
              <th>Date</th>
              <th>Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentBlogs?.map((blog) => (
              <tr key={blog._id}>
                <td>{blog.title}</td>
                <td>{formatDate(blog.createdAt)}</td>
                <td>{blog.categories[0]}</td>
                <td>
                  <Button
                    variant='secondary'
                    size='md'
                    onClick={() => {
                      console.log('click');
                      //   navigate(`/users/${user.id}`);
                    }}
                  >
                    <BsThreeDots />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <TablePaginationBar
          currentPage={currentPage}
          totalItems={blogs.length}
          rowsPerPage={blogsPerPage}
          onPageChange={paginate}
        />
      </div>
    </>
  );
};

export default HealthWellness;
